import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Slide as SlideComponent } from 'react-slideshow-image';
import 'react-slideshow-image/dist/styles.css';
import logo from "assets/images/icons/logo-color@svg.svg";
import sliderEfficiency from "assets/images/bgs/slider-efficiency.png";
import sliderFast from "assets/images/bgs/slider-fast.png";
import sliderOnDemandPay from "assets/images/bgs/slider-on-demand-pay.png";
import sliderCredit from "assets/images/bgs/slider-on-demand-pay.png";


const AuthLayout = (props) => {
    const location = useLocation();
    const [maxWidth, setMaxWidth] = useState("max-w-md");
    
    useEffect(() => {
        if(location?.pathname?.includes("/verify-email") || location?.pathname?.includes("/get-started/select-modules")) {
            setMaxWidth("max-w-2xl");
        } else {
            setMaxWidth("max-w-md");
        }
    }, [location])
    
    return ( 
        <div className="w-full min-h-screen md:flex md:justify-between relative bg-[#F9FAFB]">
            <div className="w-full md:w-1/2 lg:w-1/3 min-h-full px-8 py-12 relative bg-ep-primary bg-gradient-to-b from-ep-primary to-[#193F52] md:rounded-tr-xl rounded-br-xl rounded-bl-xl md:rounded-bl-none overflow-hidden">
                <Slider />
                <BackgroundPatterns />
            </div>
            <div className="w-full md:w-1/2 lg:w-2/3 min-h-full px-8 py-12 flex justify-center items-center">
                <div className={`w-full ${maxWidth} pt-8 pb-0 relative z-[1] bg-white border rounded-xl overflow-hidden`}>
                    <div className="w-32 h-8 mx-auto text-center overflow-hidden">
                        <img src={logo} alt="logo" className="w-full h-full object-contain" />
                    </div>
                    <div>
                        {props.children}
                    </div>
                </div>
            </div>
        </div>
    );
}


const Slider = () => {
    const slideshowProperties = {
        duration: 3000,
        transitionDuration: 300,
        pauseOnHover: true,
        indicators: true,
        autoplay: true,
        infinite: true,
        canSwipe: true,
        prevArrow: <div></div>,
        nextArrow: <div></div>,
    }
    
    return ( 
        <div className="auth-slideshow w-full h-full flex items-center justify-center relative z-[2]">
            {/* <div className="w-full max-w-md m-auto pb-14 md:pb-0"> */}
            <div className="w-full">
                <SlideComponent {...slideshowProperties} easing="ease">
                    <Slide 
                        image={sliderEfficiency}
                        title="Build Your Payroll on Auto"
                        description="Manage and settle your growing team easily and on time."
                    />
                    <Slide 
                        image={sliderFast}
                        title="Fast and Precise Payments, Every Time"
                        description="Send payments at lightning speed, whether to one person or multiple people, all at once."
                    />
                    <Slide 
                        image={sliderOnDemandPay}
                        title="Unlock Growth Without the Price Tag"
                        description="Empower your employees with On-demand Pay, giving them control over how they access their earned money as they earn it, at zero cost."
                    />
                    <Slide 
                        image={sliderCredit}
                        title="Loans to Keep Your Business Moving Forward"
                        description="Move at the pace of your business, not the limit of your cash."
                    />
                </SlideComponent>
            </div>
        </div>
    )
}


const Slide = (props) => {
    const {image, title, description} = props;
    return ( 
        <div className="slideshow-each">
            <div className="max-w-sm md:max-w-none mx-auto">
                <div className="w-full h-48 md:h-72 xl:h-96 flex justify-center items-center">
                    <img src={image} alt={title} className="object-contain h-full" />
                </div>
                <div className="mt-10 text-center">
                    <div className="font-semibold text-ep-primary-100 text-2xl md:text-3xl">
                        {title}
                    </div>
                    <div className="mt-4 font-light text-ep-primary-200 text-lg">
                        {description}
                    </div>
                </div>
            </div>
        </div>
    )
}
  

const BackgroundPatterns = () => {    
    return ( 
        <>
            <div className="auth-bg-1"></div>
            <div className="auth-bg-2"></div>
            <div className="auth-bg-3"></div>
        </>
    )
}
 

export default AuthLayout;
